import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { styled } from '@mui/material';
import React from 'react';
import '../../../analytics/events.js';
import 'uuid';
import 'lodash/includes';
import '../../../types/filters.js';
import { getImageAssetUrl } from '../../../utils/assetUtils.js';
import '../../../utils/brandclubStoreConfigUtils.js';
import 'numeral';
import 'he';
import '../../../utils/broadcast.js';
import '../../../utils/constants/Constants.js';
import 'awesome-phonenumber';
import 'lodash/isEqual';
import 'lodash/get';
import 'lodash/orderBy';
import '../../../types/Campaign.js';
import '../../../types/product.js';
import '../../../api/graphQl/brand.js';
import '../../../api/graphQl/product.js';
import '@brandclub/types';

var StyledContainer = styled('div', {
    shouldForwardProp: function (prop) { return !['isClickable'].includes(prop.toString()); },
})(function (_a) {
    var isClickable = _a.isClickable, theme = _a.theme;
    return ({
        background: theme.palette.primary.main,
        borderRadius: 999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 37,
        height: 37,
        ':hover': {
            cursor: isClickable ? 'pointer' : 'default',
        },
    });
});
var ShareIcon = function (_a) {
    var _b = _a.containerStyle, containerStyle = _b === void 0 ? {} : _b, _c = _a.imgProps, imgProps = _c === void 0 ? {} : _c;
    var styleOverride = imgProps.style, onClick = imgProps.onClick, restImgProps = __rest(imgProps, ["style", "onClick"]);
    return (React.createElement(StyledContainer, { isClickable: !!onClick, style: containerStyle, onClick: onClick },
        React.createElement("img", __assign({ src: getImageAssetUrl('affiliate-reward-icon.webp'), alt: "share-icon", style: __assign({ width: 18, height: 14.4 }, styleOverride) }, restImgProps))));
};

export { ShareIcon as default };
//# sourceMappingURL=ShareIcon.js.map
